import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { StandardURL } from "../App";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    fetchNotifications();
  }, []);

  const fetchNotifications = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${StandardURL}/iNyumba/inappnotifications/viewallnotifications`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setNotifications(response.data.response);
    } catch (error) {
      console.error("Error fetching notifications:", error);
      toast.error("Error fetching notifications");
    }
  };

  return (
  <div className="container mx-auto px-4 py-8 sm:px-6 lg:px-8"> {/* Added responsive horizontal padding */}
    <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-6 text-center tracking-tight"> {/* Larger, bolder title */}
      Notifications ✨
    </h1>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"> {/* Increased gap for more breathing room, adjusted breakpoints */}
      {notifications.map((notification) => (
        <div
          key={notification.notificationid}
          className="bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-xl p-5 border border-gray-100 flex flex-col justify-between" // Enhanced shadow, transition, rounded corners, added border, flex for content distribution
        >
          <h2 className="text-2xl font-bold text-gray-800 mb-3 flex items-center"> {/* Larger, more prominent heading */}
            <span className="mr-2 text-blue-500">📣</span> Notification !!!
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4 flex-grow"> {/* Improved line height, flex-grow for spacing */}
            {notification.notification}
          </p>
          <p className="text-gray-500 text-sm italic border-t border-gray-200 pt-3"> {/* Italic, top border for separation */}
            <span className="font-medium">Received:</span> {new Date(notification.created_at).toLocaleString()}
          </p>
        </div>
      ))}
    </div>
  </div>
);
};

export default NotificationsPage;
